"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rounding = void 0;
class Rounding {
    constructor() {
    }
    static getRounding(roundingMethod, noOfDecimals) {
        const rounding = new Rounding();
        if (!roundingMethod) {
            roundingMethod = 'NEAREST';
        }
        if (noOfDecimals === undefined) {
            noOfDecimals = 2;
        }
        rounding.method = roundingMethod;
        rounding.noOfDecimals = noOfDecimals;
        return rounding;
    }
    round(amount) {
        let roundedAmount = amount;
        switch (this.method) {
            case 'DOWN':
                roundedAmount = Math.floor((amount) * Math.pow(10, this.noOfDecimals)) / Math.pow(10, this.noOfDecimals);
                break;
            case 'UP':
                roundedAmount = Math.ceil((amount) * Math.pow(10, this.noOfDecimals)) / Math.pow(10, this.noOfDecimals);
                break;
            case 'NEAREST':
                roundedAmount = Math.round((amount) * Math.pow(10, this.noOfDecimals)) / Math.pow(10, this.noOfDecimals);
                break;
        }
        return roundedAmount;
    }
}
exports.Rounding = Rounding;
//# sourceMappingURL=rounding-method.js.map